<template>
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="35"
      height="35"
      rx="17.5"
      fill="var(--livi-primary)"
      fill-opacity="0.2"
    />
    <path
      d="M22.5 7.61372H19.5V9.04586H23.3923V28.0624H11.6952V9.81069V9.04586L12.25 9.04175H15.5V7.61372H12.5C11.9696 7.61372 11.4609 7.84518 11.0858 8.2572C10.7107 8.66921 10.5 9.22802 10.5 9.81069V27.3864C10.5 27.9691 10.7107 28.5279 11.0858 28.9399C11.4609 29.3519 11.9696 29.5834 12.5 29.5834H22.5C23.0304 29.5834 23.5391 29.3519 23.9142 28.9399C24.2893 28.5279 24.5 27.9691 24.5 27.3864V9.81069C24.5 9.22802 24.2893 8.66921 23.9142 8.2572C23.5391 7.84518 23.0304 7.61372 22.5 7.61372ZM17.5 12.0077C18.0304 12.0077 18.5391 12.2391 18.9142 12.6511C19.2893 13.0631 19.5 13.622 19.5 14.2046C19.5 14.7873 19.2893 15.3461 18.9142 15.7581C18.5391 16.1701 18.0304 16.4016 17.5 16.4016C16.9696 16.4016 16.4609 16.1701 16.0858 15.7581C15.7107 15.3461 15.5 14.7873 15.5 14.2046C15.5 13.622 15.7107 13.0631 16.0858 12.6511C16.4609 12.2391 16.9696 12.0077 17.5 12.0077ZM21.5 20.7955H13.5V19.6971C13.5 18.2361 16.17 17.5001 17.5 17.5001C18.83 17.5001 21.5 18.2361 21.5 19.6971V20.7955ZM21.5 24.0141H13.5V22.9925H21.5V24.0141ZM17.5 25.9584H13.5V25.0624H17.5V25.9584ZM18.2793 9.81069H16.7495V5.41675H18.2793V9.81069Z"
      fill="var(--livi-primary)"
      stroke="#D5E6F5"
      stroke-width="0.4"
    />
  </svg>
</template>
